import Tooltip from 'components/Tooltip';
import { DateTime } from 'luxon';
import React from 'react';
import type { DayModifiers } from 'react-day-picker';
import type { StartOfWeek } from 'types/account';
import { getLastDayOfWeek } from 'utils/date-helper';
import { fromJSDate } from 'utils/luxon-helpers';

interface Props {
  day: Date;
  modifiers: DayModifiers;
  startOfWeek: StartOfWeek;
  today: string;
  capacity: number | null;
}

const DatePickerDay: React.FC<Props> = ({ day, modifiers, startOfWeek }) => {
  if (modifiers.outside) {
    return <span />;
  }
  const date = fromJSDate(day);
  const isoDate = date.toISODate();
  const isToday = date.hasSame(DateTime.now(), 'day');
  const title = isToday ? 'Today' : modifiers.selected ? 'Selected date' : undefined;
  const lastDayOfWeek = getLastDayOfWeek(isoDate, startOfWeek);

  return (
    <Tooltip
      title={title}
      position={lastDayOfWeek === isoDate ? 'left' : undefined}
      data-testid="single_day"
    >
      {day.getDate()}
    </Tooltip>
  );
};

DatePickerDay.displayName = 'DatePickerDay';

export default DatePickerDay;
